export { default } from './CoachingHistory';
export type { CoachingHistoryProps } from './CoachingHistory.types';
